var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHackathonBackground1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 535,
    height: 549,
    viewBox: "0 0 535 549",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-122.6 1096.5L96.6 1096.5L96.6 877.3L315.8 877.3L315.8 658.1L535 658.1L535 438.9L315.8 438.9L315.8 219.7L96.6 219.7L96.6 0.500084L-122.6 0.500065L-122.6 219.7L-341.8 219.7L-341.8 438.9L-561 438.9L-561 658.1L-341.8 658.1L-341.8 877.3L-122.6 877.3L-122.6 1096.5ZM-122.6 658.1L96.6 658.1L96.6 438.9L-122.6 438.9L-122.6 658.1Z",
    fill: "#00BDE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHackathonBackground1);
export default __webpack_public_path__ + "static/media/hackathon-background1.ef691ad1ae1a0bb8904a4c4447337b09.svg";
export { ForwardRef as ReactComponent };